const rootActionPath = 'core/navBanner';

export const NAV_BANNER_IS_VIEWED = `${rootActionPath}/IS_VIEWED`;
